import {
    SITEPLAN_UPDATE,
    SITEPLAN_QUERY,
    SITEPLAN_UPDATE_UNIT_OUTLINE,
    SITEPLAN_UPDATE_ACTIVE_LOT_INDEX,
    SITEPLAN_UPDATE_LOT_OUTLINES,
    SITEPLAN_UPDATE_ACTIVE_FLOORPLAN_INDEX,
    SITEPLAN_SOURCE_FLOORPLANS,
    SITEPLAN_ADD_ACTIVE_FLOORPLAN_FILTER_INDEX,
    SITEPLAN_REMOVE_ACTIVE_FLOORPLAN_FILTER_INDEX,
    SITEPLAN_ACTIVATE_ALL_LOTS_OF_TYPE,
    SITEPLAN_DEACTIVATE_ALL_LOTS_OF_TYPE,
    SITEPLAN_CLEAR_ACTIVE_FLOORPLAN_FILTERS
} from './actionTypes';
import apiService from '../../services/apiService';

function siteplan_notify() {
    return {
        type: SITEPLAN_QUERY
    }
}

function updateSiteplan(siteplan) {
    return {
        type: SITEPLAN_UPDATE,
        siteplan
    }
}

export function sourceSiteplanFloorplans(floorplans) {
    return {
        type: SITEPLAN_SOURCE_FLOORPLANS,
        floorplans
    }
}

export function updateSiteplanLotActiveIndex(index) {
    return {
        type: SITEPLAN_UPDATE_ACTIVE_LOT_INDEX,
        activeLotIndex: index
    }
}

export function updateSiteplanActiveFloorplanID(ID) {
    return {
        type: SITEPLAN_UPDATE_ACTIVE_FLOORPLAN_INDEX,
        ID
    }
}

export function addSiteplanActiveFloorplanFilterID(ID) {
    return {
        type: SITEPLAN_ADD_ACTIVE_FLOORPLAN_FILTER_INDEX,
        ID,
    }
}

export function removeSiteplanActiveFloorplanFilterID(ID) {
    return {
        type: SITEPLAN_REMOVE_ACTIVE_FLOORPLAN_FILTER_INDEX,
        ID
    }
}

export function activateAllLotsOfType(lots) {
    return {
        type: SITEPLAN_ACTIVATE_ALL_LOTS_OF_TYPE,
        lots
    }
}

export function deactivateAllLotsOfType(lots) {
    return {
        type: SITEPLAN_DEACTIVATE_ALL_LOTS_OF_TYPE,
        lots
    }
}

export function clearAllFloorplanFilters() {
    return {
        type: SITEPLAN_CLEAR_ACTIVE_FLOORPLAN_FILTERS
    }
}

export function updateSiteplanLotOutlines() {
    return {
        type: SITEPLAN_UPDATE_LOT_OUTLINES
    }
}


export function updateUnitOutline(ID, mini = false, ele = -1) {
    return {
        type: SITEPLAN_UPDATE_UNIT_OUTLINE,
        ID,
        mini,
        ele
    }
}

export function querySiteplan() {
    return function(dispatch) {
        dispatch(siteplan_notify);
        return apiService.get('get-siteplan-data')
        .then(response => {
            dispatch(updateSiteplan(response.data));
        }).catch(err => {
            console.error(err);
        });
    }
}